import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query"
import NotAvailable from 'components/common/NotAvailable'
import Loader from 'components/general/Loader';
import Label from "components/general/Label"
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import MirsTable from "components/general/table/Table";
import { getCommunications } from "data/Querys";
import SportCode from "components/common/SportCode";
import Noc from "components/presentation/Noc"
import { Stack } from "react-bootstrap";
import DateTime from "components/presentation/DateTime";
import useViewport from "components/general/useViewPort";
import { getDateTimeFormat } from "helpers/utils";

const HearingSchedule = () => {
  const { breakPoint } = useViewport();
  const { mirs_competition, mirs_discipline } = useUrlFriendlyToParameters()
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['comms', mirs_competition, mirs_discipline],
      queryFn: getCommunications,
      refetchInterval: 10000,
      staleTime: 10000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //onError: (error) =>console.error(`Something went wrong: ${error.message}`),
    }
  )

  //remove if() to make it work for every sport
  if (mirs_discipline === "sal" || mirs_discipline === "SAL") {
    data?.communications?.sort((e) => e.protest?.hearingTime === undefined ? -1 : e.protest?.hearingTime)
  }

  const tableColumns = useMemo(() =>
    [
      {
        id: "date",
        Header: <Label data="HeaderDate" />,
        accessor: "date",
        className: "text-start",
        Cell: (props) => {
          let row = props.cell.row.original
          let val = row?.protest?.hearingTime
          const formatDate = getDateTimeFormat('DayMonthShort');
          return (
            <DateTime datetime={val} format={formatDate} />
          )
        }
      },
      {
        id: "time",
        Header: <Label data="HeaderTime" />,
        className: "text-start",
        Cell: (props) => {
          let row = props.cell.row.original
          let val = row?.protest?.hearingTime
          return (
            <DateTime datetime={val} format={"HH:mm"} />

          )
        }
      },
      {
        id: "number",
        Header: <Label data="HeaderCaseNum" />,
        className: "text-start",
        columnIndex: 1,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          return (
            row?.id
          )
        }
      },
      {
        id: "status",
        Header: <Label data="HeaderStatus" />,
        className: "text-start",
        columnIndex: 2,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          let val = row?.protest?.status
          return (
            <SportCode entity="@ProtestStatus" discipline="SAL" code={val} />
          )
        }
      },
      {
        id: "event",
        Header: <Label data="HeaderEvent" />,
        className: "text-start",
        columnIndex: 3,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          return (
            row?.protest?.unit?.phase?.event?.description
          )
        }
      },
      {
        id: "race",
        Header: <Label data="HeaderRace" />,
        className: "text-start",
        columnIndex: 4,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          return (
            row?.protest?.unit?.shortDescription
          )
        }
      },
      {
        id: "initiator",
        Header: <Label data="HeaderInitiator" />,
        className: "text-start",
        columnIndex: 5,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          return (
            row?.protest?.initiator
          )
        }
      },
      {
        id: "respondent",
        Header: <Label data="HeaderRespondent" />,
        className: "text-start",
        columnIndex: 6,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          let val = row?.protest?.respondent
          return (
            <Stack direction="horizontal">
              <Noc showOnlyImage={true} code={val} />
              <div>{val}</div>
            </Stack>
          )
        }
      },
      {
        id: "witness",
        Header: <Label data="HeaderWitness" />,
        className: "text-start",
        columnIndex: 7,
        isVisible: false,
        Cell: (props) => {
          let row = props.cell.row.original
          return (
            row?.protest?.witness
          )
        }
      }
    ]
    , [])

  if (isError) { return <NotAvailable label={'LabelNoDataDailyComponent'} /> }
  if (isLoading) { return <Loader /> }

  let tableData = data?.communications?.filter(c => c.type === 'PROTEST' && c.protest?.status !== 'CLS') || []

  if (!tableData || tableData?.length === 0) { return <NotAvailable label={'LabelNoDataDailyComponent'} /> }

  return (
    <>
      <PageHeader title={<Label data="LabelHearingSchedule" />} />
      <div className='mirs-page-container'>
        <MirsTable
          id={`mirs-table-hearing-schedule`}
          data={tableData}
          columns={tableColumns}
          showLoading={false}
          initialSortBy={["date"]}
          colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '4,3' : '7'}
          showNavExtendedData={true}
          colIndex={1}
        />
      </div>
    </>
  )
}

export default HearingSchedule